import React from "react";
import { Bar } from 'react-chartjs-2';


const Bar100 = ({ name, player1, player2, leftColor, rightColor }) => {
      const notch = {
        id: 'xNotch',
        beforeDatasetsDraw(chart, args, plugins) {
          const { ctx, scales: {x, y}, config: { options: {barThickness} } } = chart;
          ctx.save();
          const arrowHeight = barThickness / 2;
          const arrowWidth = arrowHeight / 3;
          const top = y.top + 3;
          // Set up a mask that clips out a notch when rendering the bar
          ctx.beginPath();
          //ctx.strokeStyle = 'rgba(0, 0, 0, 1.0)';
          ctx.moveTo(x.left, top);
          ctx.lineTo((x.left + x.right) / 2 - arrowWidth, top);
          ctx.lineTo((x.left + x.right) / 2, top + arrowHeight);
          ctx.lineTo((x.left + x.right) / 2 + arrowWidth, top);
          ctx.lineTo(x.right, top);
          ctx.lineTo(x.right, y.bottom);
          ctx.lineTo(x.left, y.bottom);
          ctx.closePath();
          ctx.clip();
          //ctx.stroke(); // just for debugging
        },
        afterDatasetsDraw(chart, args, plugins) {
          const { ctx } = chart;
          ctx.restore();
        }
      };
    
    return (
        <div className='bar'>
            <div className="bar__numbers">
                <h1 className="text-white pl-6">{parseInt(player1)}</h1>
                <h1 className="text-white float-right pr-24">{parseInt(player2)}</h1>
            </div>

            <h1 className='bar__header'>{name}</h1>
            <Bar
                redraw={true}
                data={{
                    labels: ["", ""],
                    datasets: [
                        {
                            label: "good",
                            data: [player1],
                            backgroundColor: leftColor,
                        },
                        {
                            label: "better",
                            data: [player2],
                            backgroundColor: rightColor,
                        },

                    ],
                }}
                options={{
                    animation: false,
                    maintainAspectRatio: false,
                    //@ts-ignore
                    indexAxis: "y",
                    barThickness: 32,
                    plugins: {
                        legend: {
                            display: false
                        },
                        stacked100: { 
                            enable: true,
                        },
                    },
                    scales: {
                        y: {
                            display: false,
                            grid: {
                                display: false
                            }
                        },
                        x: {
                            grid: {
                                display: false,
                            },
                            display: false,
                        }
                    }
                }}
                plugins={[notch]}
            />
        </div>
    )
}

export { Bar100 };
